import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const FallBackErrorBoundray = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen">
      <div className="font-semibold text-lg text-red-600">به نظر مشکلی پیش آمده است! لطفا مجددا تلاش نمایید.</div>
      <Button
        size="large"
        type="primary"
        className="mt-6"
        onClick={() => {
          navigate("/");
          resetErrorBoundary();
        }}
      >
        صفحه اصلی
      </Button>
    </div>
  );
};

export default FallBackErrorBoundray;
